import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import styled from "styled-components";

export const SheldonImage = styled.img`
  height: 5rem;
  width: 5rem;
`;

export const SheldonSummaryWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-top: 2.8rem;
`;

export const ResponseWrapper = styled.div`
  border: 1px solid ${vars.colors.grey100};
  border-radius: 1rem;
  width: 100%;
  padding: 1.4rem 1.2rem;

  background-image: radial-gradient(circle at 10px 10px, white 0.2px, transparent 1px),
    radial-gradient(circle at 25px 20px, white 0.1px, transparent 1px),
    radial-gradient(circle at 30px 10px, white 0.1px, transparent 2px),
    radial-gradient(circle at 120px 30px, white 0.1px, transparent 1px),
    radial-gradient(circle at 150px 120px, white 0.3px, transparent 1.5px),
    radial-gradient(circle at 200px 80px, white 0.1px, transparent 2px),
    radial-gradient(circle at 250px 60px, white 0.3px, transparent 1px),
    radial-gradient(circle at 300px 200px, white 0.2px, transparent 3px),
    radial-gradient(circle at 350px 260px, white 0.1px, transparent 2px);
  background-repeat: repeat;
  background-size: 300px 150px; /* Tiles now repeat more often across the screen */
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Title = styled(Paragraph)`
  background: linear-gradient(108deg, #d1d1d6 35%, #6d6d70 71.25%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  font-style: normal;
  margin-right: 0.4rem;
`;

export const ResponseBody = styled(Paragraph)`
  margin-top: 1rem;
  > div:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`;

export const Button = styled.button`
  color: ${vars.colors.sky};
  border-radius: 1.4rem;
  padding: 0 0.5rem;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.6rem;
  border: 2px solid transparent;
  background-image: linear-gradient(#2a3641, #2a3641), linear-gradient(90deg, #64b1fd, #3c6a97);
  background-origin: padding-box, border-box;
  background-clip: padding-box, border-box;
  margin-right: 1px;

  svg {
    width: 1.5rem;
    height: 1.5rem;
    path {
      stroke: ${vars.colors.sky};
    }
  }
`;

export const Feedback = styled.div`
  margin-left: 0.8rem;
  padding: 0.8rem;
  border-radius: 3rem;
  border: 1px solid ${vars.colors.grey90};
  background: ${vars.colors.grey100};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    width: 1.8rem;
    height: 1.8rem;
  }
`;
